import { useState } from 'react';

interface IconSelectorProps {
  selectedIcon: string;
  onIconSelect: (icon: string) => void;
}

const ICON_CATEGORIES = {
  'Geral': ['fa-home', 'fa-star', 'fa-heart', 'fa-shopping-bag', 'fa-tag', 'fa-fire', 'fa-gift', 'fa-trophy'],
  'Navegação': ['fa-arrow-left', 'fa-arrow-right', 'fa-chevron-left', 'fa-chevron-right', 'fa-chevron-up', 'fa-chevron-down', 'fa-search', 'fa-filter'],
  'Ações': ['fa-plus', 'fa-minus', 'fa-edit', 'fa-trash', 'fa-save', 'fa-check', 'fa-times', 'fa-download'],
  'Comunicação': ['fa-envelope', 'fa-phone', 'fa-comment', 'fa-bell', 'fa-share', 'fa-paper-plane', 'fa-whatsapp'],
  'Social': ['fa-user', 'fa-users', 'fa-user-circle', 'fa-user-friends', 'fa-user-plus', 'fa-user-minus'],
  'Categorias': ['fa-tshirt', 'fa-socks', 'fa-hat-cowboy', 'fa-shoe-prints', 'fa-glasses', 'fa-watch', 'fa-jewelry', 'fa-handbag'],
  'Produtos': ['fa-box', 'fa-box-open', 'fa-cube', 'fa-cubes', 'fa-dolly', 'fa-shipping-fast', 'fa-store', 'fa-shopping-cart'],
  'Comércio': ['fa-credit-card', 'fa-money-bill', 'fa-money-bill-wave', 'fa-cash-register', 'fa-receipt', 'fa-chart-line'],
  'Tempo': ['fa-calendar', 'fa-clock', 'fa-hourglass', 'fa-calendar-day', 'fa-calendar-week', 'fa-calendar-alt'],
  'Status': ['fa-check-circle', 'fa-times-circle', 'fa-exclamation-circle', 'fa-info-circle', 'fa-question-circle', 'fa-ban'],
};

function IconSelector({ selectedIcon, onIconSelect }: IconSelectorProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('Geral');

  const allIcons = Object.values(ICON_CATEGORIES).flat();
  const filteredIcons = searchQuery
    ? allIcons.filter(icon => icon.toLowerCase().includes(searchQuery.toLowerCase()))
    : ICON_CATEGORIES[selectedCategory as keyof typeof ICON_CATEGORIES] || [];

  return (
    <div className="icon-selector">
      <div className="icon-selector-header">
        <label className="form-label">Buscar Ícone</label>
        <input
          type="text"
          className="form-input"
          placeholder="Digite para buscar..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            if (e.target.value) setSelectedCategory('');
          }}
        />
      </div>

      {!searchQuery && (
        <div className="icon-categories">
          {Object.keys(ICON_CATEGORIES).map((category) => (
            <button
              key={category}
              type="button"
              className={`icon-category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      )}

      <div className="icon-grid">
        {filteredIcons.map((icon) => (
          <button
            key={icon}
            type="button"
            className={`icon-option ${selectedIcon === icon ? 'selected' : ''}`}
            onClick={() => onIconSelect(icon)}
            title={icon}
          >
            <i className={`fas ${icon}`}></i>
          </button>
        ))}
      </div>

      {selectedIcon && (
        <div className="selected-icon-preview">
          <span>Ícone selecionado:</span>
          <i className={`fas ${selectedIcon}`}></i>
          <span className="icon-name">{selectedIcon}</span>
        </div>
      )}
    </div>
  );
}

export default IconSelector;

